import qs from 'query-string';
import {
  BASE_URL_ELEMENT,
  PARTNER_ID_BPJS,
  PARTNER_ID_BPJS_KASBON,
  PARTNER_ID_GENERAL,
  PARTNER_ID_GENERAL_KASBON
} from '../common/config';
import moment from 'moment';
import {
  ACCESS_TOKEN,
  companyAddressPattern,
  companyNamePattern,
  FIRST_APPLY_START,
  MONTH_LIST,
  PT_BANK_RAYA_INDONESIA,
  regexEmail,
  regexMotherName,
  SCHEME_CODE_KASBON,
  SCHEME_CODE_PNANG,
  SCHEME_CODE_PNNEW
} from 'common/constants';
import {
  lastPayment,
  loading,
  setBlockScreen,
  setBottomSheet,
  setError,
  setKasbonInqRes,
  setTimer,
  statusPayment,
  stopTimer
} from 'store/actions';
import phonePrefix from './phonePrefix';
import { setCookie } from './saveToCookies';

export const updateObject = (oldObject, updatedProps) => {
  return {
    ...oldObject,
    ...updatedProps
  };
};

export const findObjectValue = (name, arr) => {
  if (!arr || !Array.isArray(arr) || arr.length === 0) {
    return {};
  }

  const value = arr.find(object => object.value === name);

  if (!value) return {};

  return value;
};

export const isObjectEmpty = value => {
  return value && Object.keys(value).length === 0;
};

export const checkMaxValue = (value, inputLength) => {
  if (value >= inputLength) {
    value = value.substring(0, inputLength);
  }
  return value;
};

export const toDate = dateString => {
  const dt = dateString.split(/-|\s/);
  return new Date(dt.slice(0, 3).reverse().join('-') + ' ' + dt[3]);
};

export const getTommorowDate = date => {
  const day = 60 * 60 * 24 * 1000;
  const tommorow = new Date(date.getTime() + day);

  return tommorow;
};

export const getNumberOfDays = (start, end) => {
  const startDate = start;
  const endDate = new Date(end);

  // One day in milliseconds
  const oneDay = 1000 * 60 * 60 * 24;

  // Calculating the time difference between two dates
  const diffInTime = endDate.getTime() - startDate.getTime();

  // Calculating the no. of days between two dates
  const diffInDays = Math.round(diffInTime / oneDay);

  return diffInDays;
};

const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'Mei',
  'Jun',
  'Jul',
  'Agt',
  'Sep',
  'Okt',
  'Nov',
  'Des'
];

export const dueDateFullFormat = date => {
  let d = '';
  d = moment.utc(date).format('YYYY-MM-DD');

  d = new Date(d);
  const dueDate =
    d.getDate() + ' ' + MONTH_LIST[d.getMonth()] + ' ' + d.getFullYear();
  return dueDate;
};

export const dueDateFormat = (date, id = '') => {
  let d = '';
  d =
    id === 'freezeApply'
      ? moment.utc(date).format('YYYY-MM-DD')
      : moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD');

  d = new Date(d);
  const dueDate =
    d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
  return dueDate;
};

export const dateSimplyMonthFormat = date => {
  const d = new Date(date);
  const simplyMonthFormat =
    d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
  return simplyMonthFormat;
};

export const generateElementURL = (
  clientId,
  userId,
  txnId,
  hashToken,
  timeStamp
) => {
  const params = {
    CLIENTID: clientId,
    userId: userId,
    txnId: txnId,
    HASHTOKEN: hashToken,
    TIMESTAMP: timeStamp
  };
  const url = BASE_URL_ELEMENT + '?' + qs.stringify(params);

  return url;
};

export const thousandFormat = (num, separator) => {
  return num
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, separator ? separator : '.');
};

export const maskingNumber = number => {
  const masking = number.replace(/.(?=.{4})/g, '*');
  return masking;
};

export const maskingName = fullName => {
  let firstName = fullName?.split(' ').slice(0, -1).join(' ');
  let lastName = fullName?.split(' ').slice(-1).join(' ');

  if (!fullName) {
    return fullName;
  }

  const maskedStrFirstName = firstName
    ? firstName?.substring(0, 2) +
      '*'.repeat(5) +
      firstName?.substring(firstName?.length - 1)
    : '';
  const maskedStrLastName = lastName
    ? lastName?.substring(0, 2) +
      '*'.repeat(5) +
      lastName?.substring(lastName?.length - 1)
    : '';

  return maskedStrFirstName + ' ' + maskedStrLastName;
};

export const rupiahFormat = new Intl.NumberFormat('id-ID', {
  style: 'decimal',
  currency: 'IDR'
});

export const removeZero = val => {
  let str = val.toString();
  return str.slice(0, 2);
};

export const convertTime = time => {
  const minutes = Math.floor(time / 60);

  const seconds = time - minutes * 60;

  return `${padTime(minutes)}:${padTime(seconds)}`;
};

export const padTime = time => {
  return String(time).length === 1 ? `0${time}` : `${time}`;
};

export const getMinutes = time => {
  const minutes = Math.floor((time % 3600) / 60);

  return `${padTime(minutes)}`;
};

export const getSecond = time => {
  const seconds = Math.floor((time % 3600) % 60);

  return `${padTime(seconds)}`;
};

export const getSecondsDifferent = value => {
  if (!value) return 0;

  const present = new Date();
  const future = new Date(value);

  return Math.floor((future.getTime() - present.getTime()) / 1000);
};

export const creditCardFormating = ccNumber => {
  if (ccNumber === undefined) {
    return '';
  }
  if (typeof val === 'number') {
    ccNumber.toString();
  }
  return ccNumber.replace(
    /(\d{4})(\d{2})(\d{5})(\d{3})(\d{1,})/g,
    '$1-$2-$3-$4-$5'
  );
};

/**
 * Extract message code from och that placed under header > channelContext
 * @param err {Object} http response error
 * @returns {String} of error message code
 */
export const getChannelContextCode = (err, ctx = 'channelcontext') => {
  const channelContext = getChannelContext(err, ctx);

  if (!channelContext.status || !channelContext.status.message) return null;
  if (channelContext.status.message.length < 1) return null;

  const message = channelContext.status.message[0];

  if (!message.messageCode) return null;

  return message.messageCode;
};

/**
 *
 * @param err
 * @param {String} ctx
 */
export const getChannelContextMsg = (err, ctx = 'channel-context') => {
  const channelContext = getChannelContext(err, ctx);

  if (!channelContext.status || !channelContext.status.message) return null;
  if (channelContext.status.message.length < 1) return null;

  const message = channelContext.status.message[0];

  if (!message.messageDesc) return null;

  return message.messageDesc;
};

/**
 * @param err {Object} http response error
 */
export const getFirstAuthorizationMode = (err, ctx = 'channelcontext') => {
  const channelContext = getChannelContext(err, ctx);

  if (!channelContext.authorization) return null;
  if (!channelContext.authorization.firstAuthorizationMode) return null;

  return channelContext.authorization.firstAuthorizationMode;
};

export const getChannelContextAdditionalInfo = (
  err,
  ctx = 'channelcontext'
) => {
  const channelContext = getChannelContext(err, ctx);

  if (!channelContext.status || !channelContext.status.message) return null;
  if (channelContext.status.message.length < 1) return null;

  const message = channelContext.status.message[0];

  if (!message.additionalInfo) return null;

  return message.additionalInfo;
};

const getChannelContext = (err, ctx) => {
  try {
    const headerValue = err?.response?.headers?.[ctx];
    if (!headerValue) return {};

    if (
      typeof headerValue !== 'string' ||
      !headerValue.trim().startsWith('{')
    ) {
      return {};
    }

    const channelContext = JSON.parse(headerValue);
    return channelContext || {};
  } catch {
    return {};
  }
};

export const removeZeroDigit = (val, long) => {
  let letter = val.toString();
  if (long === 6) {
    letter = letter.replace(/[0]{6}$/g, '');
  } else {
    letter = val;
  }
  return letter;
};

export const getCashbackFromActiveLoan = (
  disbursementDate,
  sactionAmount,
  cashbackData
) => {
  if (!cashbackData || cashbackData.length == 0) return 0;

  let deltaDate;
  const activeDate = new Date();
  const disburseDate = new Date(disbursementDate);

  deltaDate = activeDate.getDate() - disburseDate.getDate();

  if (deltaDate === 0) deltaDate = 1;
  if (deltaDate === 2) deltaDate = 3;

  const getCashbackDetail = cashbackData.find(
    data => data.amount === Number(sactionAmount)
  );
  if (!getCashbackDetail) return 0;

  const cashBackAmount = getCashbackDetail.listCashback[deltaDate];
  if (!cashBackAmount || !cashBackAmount === undefined) return 0;

  return cashBackAmount;
};

export const upperCaseFront = wording => {
  return wording.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
    return index === 0 ? word.toLowerCase() : word.toUpperCase();
  });
};

export const camelize = str => {
  return upperCaseFront(str).replace(/\s+/g, '');
};

export const convertArray = arr => {
  const objectArray = arr.reduce(
    (a, v) => ({
      ...a,
      [camelize(v.termText.toLowerCase().replace(/[^a-zA-Z ]/g, ''))]:
        v.isChecked
    }),
    {}
  );

  return objectArray;
};

export const getJsonStringify = respon => {
  return JSON.stringify(respon);
};

export const getDeviceCust = () => {
  return navigator.userAgent;
};

export const getWidthDevice = () => {
  return window.innerWidth;
};

export const getHeightDevice = () => {
  return window.innerHeight;
};

export const getValidationMotherName = formData => {
  return regexMotherName.test(formData?.mothersMaidenName?.toLowerCase());
};

export const getSchemeCodeFromPartnerId = partnerId => {
  if (partnerId === PARTNER_ID_BPJS) {
    return SCHEME_CODE_PNNEW;
  } else if (
    partnerId === PARTNER_ID_BPJS_KASBON ||
    partnerId === PARTNER_ID_GENERAL_KASBON
  ) {
    return SCHEME_CODE_KASBON;
  } else {
    return SCHEME_CODE_PNANG;
  }
};

export const getTextType = partnerId => {
  const schemeCode = getSchemeCodeFromPartnerId(partnerId);
  if (isKasbon(schemeCode)) {
    return 'TNCK';
  } else {
    return 'DTRM';
  }
};

export const getSubCodeLoanScheme = (subCodeLoanScheme, subCode) => {
  if (
    (subCodeLoanScheme === '' && subCode === '') ||
    (subCodeLoanScheme.length === 0 && subCode.length === 0)
  ) {
    return '';
  }

  return subCodeLoanScheme.find(e => e.subCode === subCode)?.subCode || null;
};

export const getUserName = (name = '') => {
  if (name.length >= 30) return name.substring(0, 30) + '...';
  else return name;
};

export const isPartnerOpenSaving = (
  partnerId,
  subCode,
  isFlowSuplesiActive = false
) => {
  const partnerSaving = [
    // PARTNER_ID_WEBVIEW_APK,
    PARTNER_ID_GENERAL_KASBON
    // PARTNER_ID_BPJS
  ];
  const conditions = [
    partnerSaving.includes(partnerId) ||
      (partnerId === PARTNER_ID_GENERAL &&
        subCode === 'RAYA' &&
        !isFlowSuplesiActive)
  ];

  return conditions.every(condition => condition);
};

export const isPartnerMigrasi = schemeCode => {
  const conditions = [
    schemeCode === SCHEME_CODE_PNNEW || schemeCode === SCHEME_CODE_PNANG
  ];

  const isSatisfied = conditions.every(condition => condition);

  return isSatisfied;
};

export const isKasbon = schemeCode => {
  if (schemeCode === SCHEME_CODE_KASBON) return true;
  else return false;
};

export const forceUpdateCompanyName = isCompanyUpdated => {
  if (isCompanyUpdated !== 'Y') return true;
  else return false;
};

export const checkMaintenanceBanner = (activatedOn, appStatus) => {
  if (
    activatedOn.find(
      item =>
        item.applicationStatus === appStatus ||
        item.applicationStatus === FIRST_APPLY_START
    )
  )
    return true;
  else return false;
};

/**
 * Turn value of select string to object
 * @param option
 * @param value
 * @returns {{codeDescription: ({value}|*), cmCode: *}}
 */
export const getSelectedOption = (value, option) => {
  if (value && value.cmCode && value.codeDescription) return value;

  const selected = option?.find(item => item.value === value);

  if (!selected || !option || !value) {
    return {
      cmCode: null,
      codeDescription: null
    };
  }

  return {
    cmCode: selected.value,
    codeDescription: selected.label
  };
};

export const redirectToPlayStoreReview = () => {
  const packageName = 'id.co.bri.pinang';
  const url = `https://play.google.com/store/apps/details?id=${packageName}`;
  window.open(url, '_blank');
};

export const logoutAction = resetLogout => {
  if (window.flutter_inappwebview) {
    window.flutter_inappwebview.callHandler('exitWebview', []);
    return;
  }

  localStorage.clear();
  sessionStorage.clear();
  setCookie(ACCESS_TOKEN, '', -1);

  resetLogout();

  // HARD NAVIGATION
  window.location.replace('/');
};

export const valueCheck = value => {
  return value === undefined ||
    value === 'undefined' ||
    value === null ||
    value === ''
    ? ''
    : value;
};

export const transform = value => {
  if (value?.cmCode) return value?.cmCode;
  return value;
};

export const notAllowedRayaCompany = (isRayaEmployed, companyName) => {
  const keywords = ['BANK RAYA', 'RAYA', PT_BANK_RAYA_INDONESIA];
  const isRayaCompany = keywords.some(keyword =>
    companyName?.toUpperCase().includes(keyword)
  );

  return isRayaEmployed !== 'Y' && isRayaCompany;
};

export const handleBlockScreen = (dispatch, dataBlockScreen) => {
  dispatch(
    setBlockScreen({
      activated: dataBlockScreen.activated,
      tittleBlockScreen: dataBlockScreen.value.tittle,
      descriptionBlockScreen: dataBlockScreen.value.description
    })
  );
};

export const buildFlagBoxList = (dispatch, dataFlagBoxSheet, dataFlagBox) => {
  const flagBoxs = [];

  if (dataFlagBoxSheet?.activated) {
    dispatch(
      setBottomSheet({
        activatedOn: dataFlagBoxSheet.activatedOn,
        tittleBottomSheet: dataFlagBoxSheet.value.tittleBottomSheet,
        descriptionBottomSheet: dataFlagBoxSheet.value.descriptionBottomSheet
      })
    );

    flagBoxs.push({
      activatedOn: dataFlagBoxSheet.activatedOn,
      titleFlagBox: dataFlagBoxSheet.value.tittle,
      descriptionFlagBox: dataFlagBoxSheet.value.description,
      typeFlagBox: dataFlagBoxSheet.type,
      property: dataFlagBoxSheet.property
    });
  }

  if (dataFlagBox?.activated) {
    flagBoxs.push({
      activatedOn: dataFlagBox.activatedOn,
      titleFlagBox: dataFlagBox.value.tittle,
      descriptionFlagBox: dataFlagBox.value.description,
      typeFlagBox: dataFlagBox.type,
      property: dataFlagBox.property
    });
  }

  return flagBoxs;
};

export const sortFlagBoxs = flagBoxs => {
  return flagBoxs.length > 1
    ? [...flagBoxs].sort((a, b) =>
        a.typeFlagBox > b.typeFlagBox || a.property > b.property ? -1 : 1
      )
    : flagBoxs;
};

// Helper for kasbon logic
export const handleKasbonAcctInq = (dispatch, kasbonRef) => {
  dispatch(setKasbonInqRes(kasbonRef));
  if (kasbonRef.isEligibleKasbon === 'N') {
    const errorKey = kasbonRef?.eligibilityDate
      ? 'not_eligible_date_kasbon'
      : 'not_eligible_min_plafond_kasbon';
    dispatch(setError(errorKey));
  }
};

// Common mappers
export const mapCmCode = data =>
  data.map(d => ({ value: d.cmCode, label: d.codeDescription }));

export const prependEmptyOption = (arr, extra = {}) =>
  [{ value: '', label: '', ...extra }].concat(arr);

export const isInvalidScheme = ({
  schemeCode,
  subCode,
  loanSchemeCodes,
  authSubCode,
  appInqRes,
  allowedAppStatus,
  allowedFlexiSchemeCodes,
  webviewSaving
}) => {
  const appInqValid = webviewSaving.some(
    item => item.schemeCode === schemeCode && item.subCode === subCode
  );
  const existingValid = webviewSaving.some(
    item =>
      loanSchemeCodes?.includes(item.schemeCode) && item.subCode === authSubCode
  );

  return (
    schemeCode &&
    ((!(appInqValid === existingValid) &&
      !allowedAppStatus.includes(appInqRes.applicationStatus?.cmCode)) ||
      !allowedFlexiSchemeCodes.includes(schemeCode))
  );
};

export const validateSubCodeAndLoading = ({
  partnerId,
  breakUpDetailsList,
  authSubCode,
  applicationStatus,
  dispatch,
  param,
  isInvalidSchemeCode
}) => {
  if (isInvalidSchemeCode) {
    param?.isDifferentScheme?.();
    return;
  }

  if (
    applicationStatus !== 'LOAN_CREATED' &&
    partnerId === PARTNER_ID_GENERAL
  ) {
    const hasValidSubCode = breakUpDetailsList?.some(e =>
      e.subCode.includes(authSubCode)
    );

    // check the sub code if not found in breakUpDetails loanNewSchemeCode
    if (!authSubCode || !hasValidSubCode) {
      dispatch(loading(false));
      dispatch(setError('system'));
      return;
    }
  }

  param?.next?.();
};

export const clearCSLocalStorage = () => {
  localStorage.removeItem('operationalDate');
  localStorage.removeItem('setCS');
  localStorage.removeItem('setCSFromFormFill');
};

export const clearTimer = dispatch => {
  dispatch(setTimer({ minutes: '', seconds: '' }));
  dispatch(stopTimer());
};

export const resetLocalStorageForDisburse = () => {
  localStorage.removeItem('disburseLifetime');
  localStorage.removeItem('countHitButton');
};

export const resetLocalStorageForPaidOffSuplesi = () => {
  localStorage.removeItem('paidOffLifeTime');
  localStorage.removeItem('countPaidOff');
};

export const clearPaymentLocalStorage = dispatch => {
  if (
    localStorage.getItem('paymentStatus') ||
    localStorage.getItem('lastPayment')
  ) {
    dispatch(statusPayment(''));
    dispatch(lastPayment(''));
    localStorage.removeItem('paymentStatus');
    localStorage.removeItem('lastPayment');
  }
};

export const getMessageCodeFromHeader = response => {
  return response?.header?.status?.message?.[0]?.messageCode || null;
};

export const isInvalidEdu = person =>
  ['SD', 'SMP'].includes(person.education?.cmCode) ||
  ['SD', 'SMP'].includes(person.lastEducation?.cmCode);

export const isInvalidPersonInfo = (person, ktpInfo) => {
  return (
    isInvalidEdu(person) ||
    !person.stayPeriod ||
    !ktpInfo?.nameWithoutTitle ||
    person.email?.length > 50 ||
    !regexEmail.test(person.email) ||
    !person.fullAddress ||
    !person.provinsi ||
    !person.kota ||
    !person.kecamatan?.cmCode ||
    !person.desa?.cmCode ||
    !sanitizeRtRw(person.rt) ||
    !sanitizeRtRw(person.rw) ||
    !person.fullAddressKtp ||
    !person.provinsiKtp ||
    !person.kotaKtp ||
    !person.kecamatanKtp?.cmCode ||
    !person.desaKtp?.cmCode ||
    !sanitizeRtRw(person.rtKtp) ||
    !sanitizeRtRw(person.rwKtp) ||
    !person.postalCode ||
    !person.postalCodeKtp ||
    isObjectEmpty(person.marriageStatus) ||
    !person.gender ||
    !person.religion
  );
};

export const isInvalidDocumentInfo = (
  doc,
  bankCode,
  accountNumber,
  regexName
) => {
  return !doc.docKey || !doc.file || !bankCode || !accountNumber || !regexName;
};

export const isInvalidContactAddress = (contactAddress, schemeCode) => {
  const addrInvalid =
    (!contactAddress || contactAddress.length < 3) &&
    isPartnerMigrasi(schemeCode);

  return addrInvalid;
};

export const isInvalidFamilyInfo = (family, schemeCode) => {
  if (!getValidationMotherName(family)) return true;

  isInvalidContactAddress(family.contactAddress, schemeCode);
};

export const isInvalidFamilyEmergencyContact = (family, phoneNo) => {
  if (!family) return;
  const num = phonePrefix(family.emergencyNumber);
  return (
    !family.emergencyNumber ||
    num.length > 14 ||
    num.length < 11 ||
    phonePrefix(phoneNo) === num
  );
};

export const isInvalidOccupationBase = (occ, notAllowedCmpny) => {
  return (
    !occ.jobTitle ||
    !occ.provinceOfWork ||
    !occ.cityOfWork ||
    !occ.districtOfWork ||
    !occ.wardOfWork ||
    !occ.postalCodeOfWork ||
    !occ.npwp ||
    occ.npwp.length < 16 ||
    !companyAddressPattern.test(occ.companyAddress) ||
    !companyNamePattern.test(occ.companyName) ||
    notAllowedCmpny ||
    !occ.endWorkingDate
  );
};

export const isInvalidOccupationSaving = (occ, flags, notAllowedCmpny) => {
  return (
    isInvalidOccupationBase(occ, notAllowedCmpny) ||
    !occ.dailyNormalTransactions ||
    !occ.fieldOfBusiness ||
    occ.fieldOfBusiness.length > 4 ||
    !occ.fieldOfWork ||
    !occ.fieldOfSubBusiness ||
    flags.needUpdateName
  );
};

export const isValidDate = input => {
  const regexDate = /^\d{4}-\d{2}-\d{2}$/;
  const regexDateTime = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}$/;
  if (!regexDate.test(input) && !regexDateTime.test(input)) {
    return false;
  }

  const onlyDate = input.split(' ')[0];
  const date = new Date(onlyDate);
  if (isNaN(date.getTime())) return false;

  return true;
};

export const lateDaysToMonths = (coreSystemDate, daysLate) => {
  const end = new Date(coreSystemDate);
  const start = new Date(end);
  start.setDate(end.getDate() - daysLate);

  let months =
    (end.getFullYear() - start.getFullYear()) * 12 +
    (end.getMonth() - start.getMonth());

  if (end.getDate() < start.getDate()) {
    months--;
  }

  const anchor = new Date(start);
  anchor.setMonth(start.getMonth() + months);

  const days = Math.floor((end - anchor) / (1000 * 60 * 60 * 24));

  return { months, days };
};

export const subtractDays = (dateString, days) => {
  const date = new Date(dateString);
  date.setDate(date.getDate() - days);

  // Format kembali ke YYYY-MM-DD
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const directToHome = history => {
  history.replace('/home');
};

export const formatPercentage = value =>
  value == null || value === 0
    ? '0%'
    : `${value.toFixed(2).replace('.', ',')}%`;

//remove all non-numeric characters
export const sanitizeRtRw = (value, length = 3) => {
  if (value == null || typeof value === 'boolean') return '';

  if (typeof value === 'number') {
    if (!Number.isInteger(value) || value < 0) return '';
    value = String(value);
  } else if (typeof value !== 'string') {
    return '';
  }

  const digits = value.replace(/\D/g, '');
  if (!digits) return '';

  return digits.length >= length ? digits : digits.padStart(length, '0');
};

export const formatDateIndonesia = dateString => {
  if (!dateString) return '';

  const date = new Date(dateString);

  if (Number.isNaN(date.getTime())) return '';

  return new Intl.DateTimeFormat('id-ID', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  }).format(date);
};

const OCCUPATION_IGNORED_KEYS = ['companyName', 'companyName2', 'watch'];

export const hasOccupationInfoData = info =>
  !!info &&
  typeof info === 'object' &&
  Object.entries(info).some(
    ([key, value]) =>
      !OCCUPATION_IGNORED_KEYS.includes(key) &&
      value !== '' &&
      value !== null &&
      value !== undefined &&
      value !== 0
  );
